import { createAction } from "@reduxjs/toolkit";

export type MiniGameData = {
  collected_at: string;
  id: string;
  is_bonus: 1 | 0;
  is_bonus_ready: boolean;
  is_finished: 1 | 0;
};

export type MiniGamesData = {
  black_and_red: MiniGameData;
  scratch_card: MiniGameData;
  slot: MiniGameData;
};

export const miniGamesInitRequest = createAction("miniGames/init/request");
export const miniGamesInitSuccess = createAction<{ games: MiniGamesData }>(
  "miniGames/init/success",
);
export const miniGamesInitFailure = createAction<string>(
  "miniGames/init/failure",
);

export const miniGamesStop = createAction("miniGames/stop");
